import cn from 'classnames';

interface IContentWithSidebarProps {
  className?: string;
}

const Sidebar: React.FC<React.PropsWithChildren<IContentWithSidebarProps>> = ({ className, children }) => {
  if (!children) return null;

  return <aside className={cn('content-with-sidebar--sidebar', className)}>{children}</aside>;
};

Sidebar.displayName = 'Sidebar';

export default Sidebar;
